export const USER_TYPE = {
  PREMIUM: 1,
  STANDARD: 2,
  LITE: 3,
  BASIC: 4,
  TRIAL: 5,
}

export const AUTHORIZATION_TYPE = {
  DISABLE: 'd',
  ALLOW: 'x',
  ONLY_ALLOW_FOR_USER_BUY_REPORT: 'b',
  ONLY_ALLOW_FOR_USER_NOT_BUY_REPORT: 'nb',
  PARTIAL_ALLOW: 'p',
}

export const AUTHORIZATION = {
  alerts: {
    list: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
    },
    detail: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
    },
    settings: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
      changeRules: {
        [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.DISABLE,
        [USER_TYPE.LITE]: AUTHORIZATION_TYPE.DISABLE,
        [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
        [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.DISABLE,
        [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
      },
    },
  },
  cartAndOrders: {
    defaultCurrencyByFS: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
    },
  },
  companyAnalysis: {
    summary: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.ONLY_ALLOW_FOR_USER_BUY_REPORT,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.PARTIAL_ALLOW,
      companyOverview: {
        [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.ALLOW,
        [USER_TYPE.LITE]: AUTHORIZATION_TYPE.ALLOW,
        [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
        [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
        [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
      },
      ownershipAnGroup: {
        [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.ALLOW,
        [USER_TYPE.LITE]: AUTHORIZATION_TYPE.DISABLE,
        [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
        [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
        [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
      },
      keyFinancials: {
        [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.ALLOW,
        [USER_TYPE.LITE]: AUTHORIZATION_TYPE.ALLOW,
        [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
        [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
        [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
      },
      score: {
        [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.ALLOW,
        [USER_TYPE.LITE]: AUTHORIZATION_TYPE.DISABLE,
        [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
        [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
        [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
      },
      recentNews: {
        [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.ALLOW,
        [USER_TYPE.LITE]: AUTHORIZATION_TYPE.DISABLE,
        [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
        [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
        [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
      },
      companyAlerts: {
        [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.ALLOW,
        [USER_TYPE.LITE]: AUTHORIZATION_TYPE.DISABLE,
        [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
        [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
        [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
      },
      topIndustryPlayers: {
        [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.ALLOW,
        [USER_TYPE.LITE]: AUTHORIZATION_TYPE.DISABLE,
        [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
        [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
        [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
      },
      filingStatus: {
        [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.ALLOW,
        [USER_TYPE.LITE]: AUTHORIZATION_TYPE.DISABLE,
        [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
        [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
        [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
      },
    },
    companyProfile: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.PARTIAL_ALLOW,
    },
    filingStatus: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.PARTIAL_ALLOW,
    },
    newsAndSocials: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.PARTIAL_ALLOW,
    },
    ownershipAndGroup: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.PARTIAL_ALLOW,
    },
    financial: {
      financialStatements: {
        [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.DISABLE,
        [USER_TYPE.LITE]: AUTHORIZATION_TYPE.DISABLE,
        [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
        [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
        [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.PARTIAL_ALLOW,
      },
      financialAnalysis: {
        [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.DISABLE,
        [USER_TYPE.LITE]: AUTHORIZATION_TYPE.DISABLE,
        [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
        [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
        [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
      },
    },
    peerAnalysis: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.PARTIAL_ALLOW,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.PARTIAL_ALLOW,
    },
    industry: {
      industryOverview: {
        [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.DISABLE,
        [USER_TYPE.LITE]: AUTHORIZATION_TYPE.DISABLE,
        [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
        [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.PARTIAL_ALLOW,
        [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.PARTIAL_ALLOW,
      },
      industryAnalysis: {
        [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.DISABLE,
        [USER_TYPE.LITE]: AUTHORIZATION_TYPE.DISABLE,
        [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
        [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.PARTIAL_ALLOW,
        [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.PARTIAL_ALLOW,
      },
    },
    score: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.PARTIAL_ALLOW,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
    },
    addToPortfolio: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
    },
    downloadAutomationReport: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.PARTIAL_ALLOW,
    },
    orderBusinessCreditReport: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.PARTIAL_ALLOW,
    },
    preferenceSettings: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
    },
    deletePanel: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
    },
    downloadPanel: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.DISABLE,
    },
    createDynamicReport: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ONLY_ALLOW_FOR_USER_BUY_REPORT,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
    },
    highLightBox: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
    },
    creditRiskScore: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
    },
    followAlerts: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
    },
    viewDetails: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
    },
  },
  dashboard: {
    [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.ALLOW,
    [USER_TYPE.LITE]: AUTHORIZATION_TYPE.ALLOW,
    [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
    [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
    [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
    Featured: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
    },
    FiinGroupNewsAndEvents: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
    },
    LatestReportsByFiinGroup: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.PARTIAL_ALLOW,
    },
    MostPopularOnFiinGate: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
    },
    RecentlyViewed: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
    },
    RiskDistribution: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
    },
    YouMayBeAlsoInterestedIn: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.PARTIAL_ALLOW,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.PARTIAL_ALLOW,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
    },
    CurrentPlan: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
    },
    YourPortfolio: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
    },
    TotalAlert: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
    },
  },
  domesticSearch: {
    [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.ALLOW,
    [USER_TYPE.LITE]: AUTHORIZATION_TYPE.ALLOW,
    [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
    [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
    [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
    preview: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.ONLY_ALLOW_FOR_USER_NOT_BUY_REPORT,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.DISABLE,
    },
  },
  dynamicReport: {
    [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.DISABLE,
    [USER_TYPE.LITE]: AUTHORIZATION_TYPE.DISABLE,
    [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
    [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.DISABLE,
    [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
  },
  internationalSearch: {
    [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.ALLOW,
    [USER_TYPE.LITE]: AUTHORIZATION_TYPE.ALLOW,
    [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
    [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
    [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
    preview: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
    },
  },
  library: {
    savedPortfolios: {
      savedPortfolio: {
        [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.DISABLE,
        [USER_TYPE.LITE]: AUTHORIZATION_TYPE.DISABLE,
        [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
        [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
        [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
      },
      detailsPortfolio: {
        [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.DISABLE,
        [USER_TYPE.LITE]: AUTHORIZATION_TYPE.DISABLE,
        [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
        [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
        [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
      },
    },
    filteredCompanies: {
      filteredCompany: {
        [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.DISABLE,
        [USER_TYPE.LITE]: AUTHORIZATION_TYPE.DISABLE,
        [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
        [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
        [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
      },
      filteredCompanySetting: {
        [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.DISABLE,
        [USER_TYPE.LITE]: AUTHORIZATION_TYPE.DISABLE,
        [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
        [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
        [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
      },
    },
    downloadFiles: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
    },
    followingList: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
    },
  },
  portfolioInsights: {
    summary: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
    },
    finance: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
    },
    score: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
    },
    segment: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.DISABLE,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
    },
  },
  screening: {
    [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.ALLOW,
    [USER_TYPE.LITE]: AUTHORIZATION_TYPE.ALLOW,
    [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
    [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
    [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
    savedCriteria: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
    },
  },
  systemNotifications: {
    [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.ALLOW,
    [USER_TYPE.LITE]: AUTHORIZATION_TYPE.ALLOW,
    [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
    [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
    [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
    systemNotifications: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
    },
    systemNotificationsSettings: {
      [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.LITE]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
      [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
    },
  },
  userManagement: {
    [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.ALLOW,
    [USER_TYPE.LITE]: AUTHORIZATION_TYPE.ALLOW,
    [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
    [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
    [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.ALLOW,
  },
  allowCheckout: {
    [USER_TYPE.BASIC]: AUTHORIZATION_TYPE.ALLOW,
    [USER_TYPE.LITE]: AUTHORIZATION_TYPE.ALLOW,
    [USER_TYPE.PREMIUM]: AUTHORIZATION_TYPE.ALLOW,
    [USER_TYPE.STANDARD]: AUTHORIZATION_TYPE.ALLOW,
    [USER_TYPE.TRIAL]: AUTHORIZATION_TYPE.DISABLE,
  },
}
